import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { Floor } from "./floor";

export class WoodenFloor extends Floor {
	static key = "WoodenFloor";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): WoodenFloor {
		const f = new WoodenFloor(deserializeXY(data.xy));
		f.visualId = data.visualId;
		return f;
	}
}
